import type { MapaCargo } from '@/components/Configuracao/mapaCargos/mapaCargosTypes'

export const CARGO_DESENVOLVEDOR_FRONTEND: MapaCargo = 
{
  id: 'desenvolvedor-frontend',
  titulo: 'Desenvolvedor FrontEnd',
  setor: 'Tecnologia',
  secoes: [
    {
      id: 'responsabilidades',
      titulo: 'Responsabilidades',
      atividades: [
        'Atender aos clientes através de telefone, whatsapp ou meet (Google);',
        'Configurar o sistema de acordo com as características dos clientes;',
        'Realizar suporte ou treinamento via Skype ou meet (google);',
        'Realizar demandas de front-end nas lojas ou sites de clientes;',
        'Acompanhar equipe ou cliente com configurações dentro da plataforma de e-commerce;',
        'Receber demandas através de e-mail e chamados via plataforma interna;',
        'Realizar cadastro de horas para controle de demandas e fechamento de mês;',
        'Realizar reuniões diárias internas para alinhamento de demandas ou tarefas;',
        'Atualizar demandas através de ferramenta interna;',
        'Desenvolvimento de novas funcionalidades nas plataformas de e-commerce;',
        'Criação de scripts de terceiros via GTM para e-commerce dos clientes;',
        'Participar de reuniões presenciais e via meet com os clientes quando se fizer necessário.',
      ],
    },
  ],
}
